<template>
  <form @submit.prevent="handleSubmit(item)">
    <b-row>
      <b-col cols="4">
        <div class="form-group">
          <label
                  for="user_username"
                  class="form-control-label">{{ $t('views.user.form.username') }}:</label>
          <input
                  id="user_username"
                  v-model="item.username"
                  :class="['form-control', isInvalid('username') ? 'is-invalid' : '']"
                  type="text"
                  required="true"
                  placeholder=""
                  @input="handleUpdateField('username', $event.target.value)">
          <div
                  v-if="isInvalid('username')"
                  class="invalid-feedback">{{ violations.username }}</div>
        </div>
      </b-col>
      <b-col cols="4">
        <div class="form-group">
          <label
                  for="user_email"
                  class="form-control-label">{{ $t('views.user.form.email') }}:</label>
          <input
                  id="user_email"
                  v-model="item.email"
                  :class="['form-control', isInvalid('email') ? 'is-invalid' : '']"
                  type="email"
                  required="true"
                  placeholder=""
                  @input="handleUpdateField('email', $event.target.value)">
          <div
                  v-if="isInvalid('email')"
                  class="invalid-feedback">{{ violations.email }}</div>
        </div>
      </b-col>
      <b-col cols="4">
        <div class="form-group">
          <label
                  for="user_plainPassword"
                  class="form-control-label">{{ $t('views.user.form.password') }}:</label>
          <b-row>
            <b-col class="pr-0">
              <input
                      id="user_plainPassword"
                      v-if="visiblePassword === 0"
                      v-model="item.plainPassword"
                      :class="['form-control', isInvalid('plainPassword') ? 'is-invalid' : '']"
                      type="password"
                      @input="handleUpdateField('plainPassword', $event.target.value)">
              <input
                      id="user_plainPassword"
                      v-else
                      v-model="item.plainPassword"
                      :class="['form-control', isInvalid('plainPassword') ? 'is-invalid' : '']"
                      type="text"
                      @input="handleUpdateField('plainPassword', $event.target.value)">
            </b-col>
            <b-col class="pl-0" cols="4">
              <b-btn variant="success" class="m-0 w-100" @click="changeVisibleState()">{{ passwordText }}</b-btn>
            </b-col>
          </b-row>
          <div
                  v-if="isInvalid('plainPassword')"
                  class="invalid-feedback">{{ violations.plainPassword }}</div>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <button type="submit" class="btn btn-primary">{{ $t('buttons.submit') }}</button>
      </b-col>
    </b-row>
  </form>
</template>

<script>
export default {
  props: {
    handleSubmit: {
      type: Function,
      required: true
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {
      visiblePassword: 0,
      passwordText: this.$t('buttons.showPassword'),
      checkboxOptions: [
        {
          value: 'ROLE_SUPER_USER',
          text: this.$t('roles.roleSuperUser')
        },
        {
          value: 'ROLE_SERVICEMAN',
          text: this.$t('roles.roleServiceman')
        },
        {
          value: 'ROLE_EXTERNAL_SERVICEMAN',
          text: this.$t('roles.roleExternalServiceman')
        },
        {
          value: 'ROLE_SALES_REPRESENTATIVE',
          text: this.$t('roles.roleSalesRepresentative')
        },
        {
          value: 'ROLE_DISPATCHER',
          text: this.$t('roles.roleDispatcher')
        },
        {
          value: 'ROLE_MANAGER',
          text: this.$t('roles.roleManager')
        },
        {
          value: 'ROLE_CLIENT',
          text: this.$t('roles.roleClient')
        },
        {
          value: 'ROLE_OWNER',
          text: this.$t('roles.roleOwner')
        }
      ]
    }
  },

  computed: {
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },

    violations () {
      return this.errors || {}
    }
  },

  methods: {
    changeVisibleState () {
      if (this.visiblePassword === 0) {
        this.visiblePassword = 1
        this.passwordText = this.$t('buttons.hidePassword')
      } else {
        this.visiblePassword = 0
        this.passwordText = this.$t('buttons.showPassword')
      }
    },

    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    }
  }
}
</script>
